{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://forms/espp",
  "title": "ESPP Offering Period",
  "description": "ESPP offering period — create, edit, and view unified form.",
  "type": "object",
  "properties": {
    "offeringPeriodId": {
      "$ref": "module://espp#properties/offeringPeriodId"
    },
    "planId": {
      "$ref": "module://espp#properties/planId",
      "required": true,
      "actionId": "FETCH_ESPP_PLAN_OPTIONS",
      "readOnlyWhen": {
        "meta": "mode",
        "in": ["edit", "view"]
      }
    },
    "name": {
      "$ref": "module://espp#properties/name",
      "required": true
    },
    "offeringPeriodStartDate": {
      "$ref": "module://espp#properties/offeringPeriodStartDate",
      "required": true
    },
    "offeringPeriodEndDate": {
      "$ref": "module://espp#properties/offeringPeriodEndDate",
      "required": true
    },
    "fmvAtStart": {
      "$ref": "module://espp#properties/fmvAtStart"
    },
    "offeringPeriodType": {
      "$ref": "module://espp#properties/offeringPeriodType",
      "required": true
    },
    "discountPercent": {
      "$ref": "module://espp#properties/discountPercent",
      "required": true
    },
    "lookback": {
      "$ref": "module://espp#properties/lookback"
    },
    "description": {
      "$ref": "module://espp#properties/description",
      "readOnly": true
    },
    "enrollmentWindowMaxChanges": {
      "$ref": "module://espp#properties/enrollmentWindowMaxChanges"
    },
    "enrollStartDaysPriorToPurchasePeriod": {
      "$ref": "module://espp#properties/enrollStartDaysPriorToPurchasePeriod"
    },
    "enrollDays": {
      "$ref": "module://espp#properties/enrollDays"
    },
    "changeWindowMaxUpChanges": {
      "$ref": "module://espp#properties/changeWindowMaxUpChanges"
    },
    "changeWindowMaxDownChanges": {
      "$ref": "module://espp#properties/changeWindowMaxDownChanges"
    },
    "changeEndDaysPriorToPurchaseDate": {
      "$ref": "module://espp#properties/changeEndDaysPriorToPurchaseDate"
    },
    "allowParticipantToSuspendWithPurchase": {
      "$ref": "module://espp#properties/allowParticipantToSuspendWithPurchase"
    },
    "allowParticipantToSuspendWithoutPurchase": {
      "$ref": "module://espp#properties/allowParticipantToSuspendWithoutPurchase"
    },
    "allowParticipantToWithdrawWithPurchase": {
      "$ref": "module://espp#properties/allowParticipantToWithdrawWithPurchase"
    },
    "allowParticipantToWithdrawWithoutPurchase": {
      "$ref": "module://espp#properties/allowParticipantToWithdrawWithoutPurchase"
    },
    "rolloverEnrollment": {
      "$ref": "module://espp#properties/rolloverEnrollment"
    },
    "nextOfferingPeriodId": {
      "$ref": "module://espp#properties/nextOfferingPeriodId",
      "actionId": "FETCH_ESPP_NEXT_OFFERING_PERIODS",
      "dependsOn": [
        "planId",
        "offeringPeriodType",
        "offeringPeriodEndDate"
      ],
      "paramMap": {
        "planId": "planId",
        "offeringPeriodType": "offeringPeriodType",
        "after": "offeringPeriodEndDate"
      },
      "disabledWhen": {
        "field": "#/properties/rolloverEnrollment",
        "notEquals": true
      }
    },
    "residualCashDisposition": {
      "$ref": "module://espp#properties/residualCashDisposition",
      "disabledWhen": {
        "field": "#/properties/rolloverEnrollment",
        "notEquals": true
      }
    },
    "purchasePeriods": {
      "$ref": "module://espp#properties/purchasePeriods",
      "items": {
        "properties": {
          "periodStartDate": { "required": true },
          "periodEndDate": { "required": true },
          "enrollmentWindowStartDate": { "required": true },
          "enrollmentWindowEndDate": { "required": true },
          "changeWindowStartDate": { "required": true },
          "changeWindowEndDate": { "required": true }
        }
      }
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_ESPP_OFFERING_PERIOD",
      "successMessage": "Offering period saved",
      "refreshEntities": [
        "OfferingPeriod"
      ]
    }
  },
  "modes": {
    "create": {
      "dataSource": {
        "submit": {
          "successMessage": "Offering period added."
        }
      },
      "lifecycle": {
        "submitBehavior": "close",
        "dirtyGuard": true
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_ESPP_OFFERING_PERIOD_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        },
        "submit": {
          "successMessage": "Offering period edited."
        }
      },
      "lifecycle": {
        "dirtyGuard": true,
        "submitBehavior": "close",
        "serverErrors": "inline"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_ESPP_OFFERING_PERIOD_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
